export function iconPath(iconName: any): unknown {
  const ctx = require.context("@/assets/icons/", false);
  return ctx("./" + iconName);
}

export function toCapitalCase(el: string): string {
  const separated = el.replace(/([A-Z])/g, " $1");
  return separated.charAt(0).toUpperCase() + separated.slice(1);
}
